import * as React from 'react';
import { Col } from '../bootstrap-components/BootstrapComponents';
import { Section } from './Section';
import { SectionGroup } from './SectionGroup';

export interface HelpCardSectionProps {
    content?: any;
    title?: any;
}

export function HelpCardSection(props: HelpCardSectionProps) {
    return (
        <div className='help-card'>
            <SectionGroup >
                <Col md={5} className='title'>
                    <h1> {props.title} </h1>
                </Col>
                <Col md={7} >
                    <Section fullWidth={true}>
                        <Col md={12} className='link-section'>
                            {props.content}
                        </Col>
                    </Section>
                </Col>
            </SectionGroup>
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/HelpCardSection.tsx